import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const communicationsHorizontalNavEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-communications-horizontal-nav-entrypoint" */ './src/ui/HorizontalCommunicationsNav'
			).then((module) => module.HorizontalCommunicationsNav),
		{ includeInShellOnlySsrBundle: true },
	),
	getPreloadProps: () => ({}),
});
